<template>
  <div class="digital-service-card">
    <div>
      <p v-if="$props.cardNotice === 'CHANGE' && $props.activationDisabled" class="card-notice">{{ $t('digitalServices.arena.cardChangeNotice') }}</p>
      <p v-else-if="$props.serviceActive && $props.cardNotice === 'DEACTIVATE' && $props.serviceName === 'arena'" class="card-notice">{{ $t('digitalServices.arena.cardCurrentNotice') }}</p>
    </div>
    <div class="card-header">
      <img v-if="$props.logo" :src="$props.logo" class="service-logo" alt="">
      <h3 class="service-title">{{ $props.title }}</h3>
      <v-popover class="service-tooltip" popover-class="addon-popover" trigger="hover" placement="left">
        <img v-if="$props.tooltip" class="info-icon"
             src="/assets/images/tooltip-info-16.png"
             alt="info-icon"
             @click="openTooltip">
        <template slot="popover" v-if="$props.tooltip">
          <div class="addon-tooltip-description">{{ $props.tooltip }}</div>
        </template>
      </v-popover>
    </div>
    <div class="card-body">
      <p class="card-description" v-html="$props.description"></p>
    </div>
    <div v-if="!$props.freeStatus" class="price">{{ $props.price }}<span>&nbsp;{{ $t('digitalServices.currency') }}<template v-if="$props.recurringPrice">/{{ $t('digitalServices.monthly') }}</template></span></div>
    <div v-else-if='!hideBottomPurchaseInfo' class="free-period">
      <div class="free-period-title">
        <span v-if="$props.recurringPrice && $props.limitedFreeLabel">{{ $t('digitalServices.freePeriodTitle') }}</span>
        <div class="free-title">{{ $t('digitalServices.freePeriodSubtitle') }}</div>
      </div>
      <div class="strike-price">
        <div class="inner">{{ $props.oldPrice }}&nbsp;<span>{{ $t('digitalServices.currency') }}<template v-if="$props.recurringPrice">/{{ $t('digitalServices.monthly') }}</template></span></div>
      </div>
    </div>
    <div v-if='!hideBottomPurchaseInfo' class="card-footer">
      <slot name='dropdown' />
      <span v-if="alreadyActive" class="card-one-time-active">
      {{ $t('digitalServices.activePackage') }}
    </span>
      <base-button v-else-if="$props.serviceActive && $props.cardNotice !== 'ACTIVATE'" variant="secondary" class="full-width-btn" size="small" :disabled="$props.activationDisabled" @click="deactivateService">
        {{ $t('common.deactivate') }}
      </base-button>
      <base-button v-else-if="!$props.freeStatus" variant="primary" class="full-width-btn" size="small" :disabled="$props.activationDisabled" @click="activateService">
        {{ $t('common.activate') }}
      </base-button>
      <base-button v-else variant="primary" class="full-width-btn" size="small" :disabled="$props.activationDisabled" @click="activateService">
        {{ $t('digitalServices.activateServiceFree') }}
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'digital-service-card',
  props: {
    title: String,
    logo: String,
    description: String,
    tooltip: String,
    price: String,
    oldPrice: String,
    activationDisabled: Boolean,
    recurringPrice: Boolean,
    cardNotice: String,
    freeStatus: {
      type: Boolean,
      default: false
    },
    serviceActive: Boolean,
    limitedFreeLabel: {
      type: Boolean,
      default: true
    },
    serviceName: String,
    hideBottomPurchaseInfo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    alreadyActive () {
      return (!this.$props.recurringPrice && this.$props.serviceActive) || (this.$props.serviceActive && this.$props.cardNotice === 'DEACTIVATE' && this.$props.activationDisabled)
    }
  },
  methods: {
    openTooltip () {
      this.$emit('open-tooltip')
    },
    activateService () {
      if (this.$props.activationDisabled) return
      this.$emit('activate-service')
    },
    deactivateService () {
      this.$emit('deactivate-service')
    }
  }
}
</script>

<style scoped lang="scss">
$buttonWidth: 20rem;

.digital-service-card {
  position: relative;
  background: $white;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  padding: 2.2rem 1.6rem 1.6rem;
  margin-bottom: 2rem;
  flex-basis: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (map_get($breakpoints, exsm)) {
    margin: 0 1rem 2rem;
    flex-basis: calc(50% - 2rem);
    max-width: calc(50% - 2rem);
  }

  @media (map_get($breakpoints, sm)) {
    margin: 0 2rem 4rem;
    flex-basis: calc(50% - 4rem);
    max-width: calc(50% - 4rem);
  }

  @media (map_get($breakpoints, lg)) {
    flex-basis: calc(33.3334% - 4rem);
    max-width: calc(33.3334% - 4rem);
  }

  @media (map_get($breakpoints, xxl)) {
    flex-basis: calc(25% - 4rem);
    max-width: calc(25% - 4rem);
  }

  &--big {
    @media (map_get($breakpoints, sm)) {
      width: 100%;
      max-width: none;
      flex-basis: 100%;
    }

    @media (map_get($breakpoints, lg)) {
      max-width: 60%;
      flex-basis: 60%;
    }

    .price {
      margin: auto 0 0 auto!important;
    }

    .digital-card-dropdown-container {
      $dropdownMarginLeft: 4rem;
      margin-bottom: 2rem;

      @media (map_get($breakpoints, sm)) {
        margin-bottom: 0;
        width: calc(100% - (#{$buttonWidth} + #{$dropdownMarginLeft}));
      }

      .label {
        font-size: 1.2rem;
        color: $dark-grey;
        margin-bottom: .4rem;
      }

      /deep/.select-dropdown .vs__dropdown-toggle {
        background-color: $light-grey;
      }
    }

    .card-footer {
      display: flex;
      flex-direction: column;

      @media (map_get($breakpoints, sm)) {
        flex-direction: row;
        justify-content: space-between;
        align-items: end;
      }

      .base-button {
        @media (map_get($breakpoints, sm)) {
          height: 4.4rem;
          max-width: $buttonWidth;
        }
      }
    }
  }

  &.card-disabled {
    margin-top: 2rem;

    @media (map_get($breakpoints, exsm)) {
      margin-top: 0;
    }

    &::before {
      background-color: $dark-grey;
      position: absolute;
      content: '';
      top: -2.4rem;
      left: -0.4rem;
      width: calc(100% - 1.2rem);
      height: calc(100% + 2.4rem);
      border-radius: 10px;
      z-index: -1;
    }
  }

  &.card-featured-green {
    margin-top: 2rem;

    @media (map_get($breakpoints, exsm)) {
      margin-top: 0;
    }

    &::before {
      background-color: $success;
      color: $white;
      position: absolute;
      content: '';
      top: -2.4rem;
      left: -0.4rem;
      width: calc(100% - 1.2rem);
      height: calc(100% + 2.4rem);
      border-radius: 10px;
      z-index: -1;
    }
  }

  .card-notice {
    position: absolute;
    font-size: 1.2rem;
    top: -2rem;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    color: $white;
    text-align: center;
    padding: 0 1.6rem;
  }

  .card-header {
    display: flex;
    align-items: center;

    .service-logo {
      width: auto;
      max-height: 24px;
      margin-right: 1.6rem;
    }

    .service-title {
      font-size: 2.4rem;
      margin: 0;
    }

    .service-tooltip {
      margin-left: auto;
    }
  }

  .card-body {
    margin-top: 2.2rem;
    margin-bottom: 4rem;

    .card-description {
      color: $font-inactive;
      line-height: 1.43;
      font-size: 1.4rem;
    }
  }

  .price {
    font-size: 2.4rem;
    color: $primary;
    margin-bottom: 1.6rem;
    margin-top: auto;
    font-weight: 600;

    span {
      color: $light-black;
      font-size: 1.6rem;
    }
  }

  .free-period {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.6rem;
    margin-top: auto;
    align-items: flex-end;

    span {
      font-weight: 600;
      font-size: 1.2rem;
    }

    .free-title {
      font-size: 2.4rem;
      text-transform: uppercase;
      font-weight: 700;
    }

    .strike-price {
      position: relative;
      color: $primary;

      &:after {
        content: '';
        position: absolute;
        width: 100%;
        background: $primary;
        height: 1px;
        top: 15px;
      }

      .inner {
        color: $font-inactive;
        font-size: 1.4rem;
        font-weight: 700;
        line-height: 2.2
      }
    }
  }

  .full-width-btn {
    width: 100%;
  }

  .card-one-time-active {
    position: relative;
    display: block;
    padding: 1rem;
    font-weight: 500;
    line-height: 1.3;
    text-align: center;

    &::before {
      position: absolute;
      top: 0;
      left: -1.6rem;
      width: calc(100% + 3.2rem);
      height: 1px;
      background: $grey;
      content: '';
    }
  }
}
</style>
